import { render, staticRenderFns } from "./ModalContactWhatsapp.vue?vue&type=template&id=6d314d16&scoped=true&"
import script from "./ModalContactWhatsapp.vue?vue&type=script&lang=js&"
export * from "./ModalContactWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d314d16",
  null
  
)

export default component.exports